<script setup>
  import { ref, watchEffect, onUnmounted } from "vue";
  import { useMapStore } from "@/stores/MapStore";
  import { useMediaQuery } from '@/composables/useMediaQuery';

  const mapStore = useMapStore();

  const fxMapAllowedWidth = useMediaQuery('(max-width: 2600px)');
  const fxMapAllowedHeight = useMediaQuery('(max-height: 2000px)');

  const toasts = ref(new Map());
  const mapZoomListener = ref(null);

    const clearToast = (toastName) => {
      const toast = toasts.value.get(toastName);

      if (toast) {
        toast.clear()
        toasts.value.delete(toastName);
      }
    }

    const showFxMapScreenSizeToast = () => {
      if (toasts.value.has('fxMapSize')) return;

      if (window.jwc) {
        const toast = window.jwc.toaster.toast({
          type: 'warning',
          title: 'Screen Size Too Large',
          content: 'Forecast maps will not display at this screen size. <i>Maximum size is 2600 x 2000 pixels.</i>',
        })

        toasts.value.set('fxMapSize', toast);
      }
    }

    const checkRadarMapZoomLevel = () => {      
      if (window.$JWX.map && window.$JWX.map.getZoom() === 13) {
        if (window.jwc && !toasts.value.has('radarZoomLevel')) {
          const toast = window.jwc.toaster.toast({
            type: 'warning',
            title: 'Max Zoom Level',
            content: 'Turn radar off to zoom in further.',
          })

          toasts.value.set('radarZoomLevel', toast);
        }
      } else {
        clearToast('radarZoomLevel');
      }
    }

    watchEffect(() => {
    if (mapStore.state.obsOverlays.has('radar')) {
      checkRadarMapZoomLevel();

      mapZoomListener.value = window.$JWX.map.addListener('zoom_changed', checkRadarMapZoomLevel)
    } else {
      clearToast('radarZoomLevel')
    }
  })

  watchEffect(() => {
      if (mapStore.mapMode.toLowerCase() === 'fx' && (!fxMapAllowedWidth.value || !fxMapAllowedHeight.value)) {
        showFxMapScreenSizeToast();
      } else {
        clearToast('fxMapSize')
      }
    })    

    onUnmounted(() => {
      if (mapZoomListener.value) {
        window.$JWX.map.removeListener(mapZoomListener.value);
      }

      toasts.value.forEach((toast) => {
        toast.clear();
      });
    })
</script>

<template></template>